// extracted by mini-css-extract-plugin
export default {"key-factors-list":"key-factors-list--mp-cIqDx","keyFactorsList":"key-factors-list--mp-cIqDx"};